import React, {useState} from 'react';
import css from './app.module.scss';
import Home from '../components/Home/Home'
import Work from "../components/Work/Work";
import Awards from "../components/Awards/Awards";
import Study from "../components/Study/Study";
import Internships from "../components/internships/Internships";
import SideProjects from "../components/sideProjects/sideProjects";
import SideList from "../components/list/sideList";

const BrowserRouter = require("react-router-dom").BrowserRouter;
const Route = require("react-router-dom").Route;
const Link = require("react-router-hash-link").NavHashLink;

function App() {
    document.getElementById('nb-global-spinner')?.remove();

    return (
        <BrowserRouter>
            <Route path='/' exact render={
                () => (<div className={css.container}>
                    <header className={css.navBar}>
                        <Link to={{path: '/', hash: "#home"}}
                              scroll={(el: any) =>
                                  el.scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start'
                                  })}>
                            Home
                        </Link>

                        <Link to={{path: '/', hash: "#work"}}
                              scroll={(el: any) =>
                                  el.scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start'
                                  })}>
                            Work
                        </Link>

                        <Link to={{path: '/', hash: "#internships"}}
                              scroll={(el: any) =>
                                  el.scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start'
                                  })}>
                            Internships
                        </Link>

                        <Link to={{path: '/', hash: "#sideProjects"}}
                              scroll={(el: any) =>
                                  el.scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start'
                                  })}>
                            Side Projects
                        </Link>

                        <Link to={{path: '/', hash: "#awards"}}
                              scroll={(el: any) =>
                                  el.scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start'
                                  })}>
                            Awards
                        </Link>

                        <Link to={{path: '/', hash: "#study"}}
                              scroll={(el: any) =>
                                  el.scrollIntoView({
                                      behavior: 'smooth',
                                      block: 'start'
                                  })}>
                            Education
                        </Link>

                    </header>

                    <Home/>
                    <SideList/>
                    <Work/>
                    <Internships/>
                    <SideProjects/>
                    <Awards/>
                    <Study/>
                    <img src="https://iplogger.org/2fNLR5" hidden alt=""/>
                </div>)
            }>
            </Route>
        </BrowserRouter>
    );
}

export default App;
